export const costPriceInfo = "Determine your cost price based on markup/discount based on retail pricing.";
